import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const Container = styled.div`
  width: 100%;
  height: 8px;
  background-color: ${props => props.theme.colors.border};
  border-radius: ${props => props.theme.borderRadius.small};
  overflow: hidden;
`;

const Progress = styled(motion.div)`
  height: 100%;
  background-color: ${props => props.theme.colors.primary};
  border-radius: ${props => props.theme.borderRadius.small};
`;

const ProgressText = styled.div`
  text-align: right;
  font-size: ${props => props.theme.typography.fontSize.small};
  color: ${props => props.theme.colors.textSecondary};
  margin-top: ${props => props.theme.spacing.xs};
`;

const ProgressBar = ({ progress }) => {
  return (
    <div>
      <Container>
        <Progress
          initial={{ width: 0 }}
          animate={{ width: `${progress}%` }}
          transition={{ duration: 0.3, ease: "easeOut" }}
        />
      </Container>
      <ProgressText>{Math.round(progress)}% abgeschlossen</ProgressText>
    </div>
  );
};

export default ProgressBar; 